import React, { useState } from "react";
import { MetodosPagoABM } from "./MetodosPago/MetodosPagoABM";
import { MetodosPagoListado } from "./MetodosPago/MetodosPagoListado";
import { type MetodoPago } from "@/lib/api";
import { useRegisterOpcionesAbmNav } from "./opcionesAbmBreadcrumb";

type MPView = "ABM" | "Listado";

export function MetodosPagoSection() {
  const [currentView, setCurrentView] = useState<MPView>("Listado");
  const [selectedItem, setSelectedItem] = useState<MetodoPago | null>(null);

  const handleEdit = (item: MetodoPago) => {
    setSelectedItem(item);
    setCurrentView("ABM");
  };

  const handleBack = () => {
    setSelectedItem(null);
    setCurrentView("Listado");
  };

  const handleNew = () => {
    setSelectedItem(null);
    setCurrentView("ABM");
  };

  useRegisterOpcionesAbmNav(
    currentView === "ABM",
    selectedItem != null,
    handleBack
  );

  return (
    <div className="space-y-4">
      {currentView === "ABM" ? (
        <MetodosPagoABM
          selectedItem={selectedItem}
          onBack={handleBack}
          onSaved={handleBack}
        />
      ) : (
        <MetodosPagoListado onEdit={handleEdit} onNew={handleNew} />
      )}
    </div>
  );
}